import React from 'react';
import { Table, ConfigProvider, theme, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import type { SortOrder } from 'antd/es/table/interface';
import type { AlignType } from 'rc-table/lib/interface';
import { ResearchReport } from '../../services/getResearch';

import '../PPITable/PPITable.scss'; // Reuse styles

interface ResearchTableProps {
    reports: ResearchReport[];
}

const ResearchTable: React.FC<ResearchTableProps> = ({ reports }) => {

    const columns = [
        {
            title: 'Report Date',
            dataIndex: 'created_at',
            key: 'created_at',
            defaultSortOrder: 'descend' as SortOrder,
            sorter: (a: ResearchReport, b: ResearchReport) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),

        },
        {
            title: 'Vehicle',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'View/Edit Report',
            key: 'edit',
            align: 'center' as AlignType,
            render: (_: any, record: ResearchReport) => (
                <Button
                    type="link"
                    icon={<EyeOutlined />}
                    onClick={() => {
                        // Assuming the route for research reports is /research-report or similar
                        // If it's the same as PPI, we might need to change this.
                        // For now, I'll use a distinct route to be safe, or maybe /research?
                        window.location.href = `#/research/report?docId=${record.id}`;
                    }}
                />
            ),
        }
    ];

    return (
        <div className="ppi-reports-section" style={{ maxWidth: '800px', margin: '48px auto 0' }}>
            <h2>Past Research Reports</h2>
            <ConfigProvider
                theme={{
                    algorithm: theme.darkAlgorithm
                }}
            >
                <Table
                    dataSource={reports}
                    columns={columns}
                    rowKey="id"
                    pagination={{ pageSize: 10 }}
                    size="small"
                    showSorterTooltip={{ target: 'sorter-icon' }}
                    style={{
                        border: '1px solid #303030',
                        borderRadius: '8px',
                        overflow: 'hidden'
                    }}
                />
            </ConfigProvider>
        </div>
    );
};

export default ResearchTable;
